import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { FavouriteTeenInput, PageQuery } from '@teentack/shared';
import { addFavourite, fetchFavourites, removeFavourite } from './favourites.api';

export const favouriteKeys = {
  all: ['favourites'] as const,
  list: (query: Partial<PageQuery>) => ['favourites', 'list', query] as const,
};

export function useFavourites(query: Partial<PageQuery> = {}, enabled = true) {
  return useQuery({
    queryKey: favouriteKeys.list(query),
    queryFn: () => fetchFavourites(query),
    enabled,
  });
}

export function useAddFavourite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: FavouriteTeenInput) => addFavourite(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: favouriteKeys.all });
    },
  });
}

export function useRemoveFavourite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (teenId: string) => removeFavourite(teenId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: favouriteKeys.all });
    },
  });
}
